import React, { useEffect, useState } from "react";
import {
  Dialog,
  Paper,
  Grid,
  Box,
  Button,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import Autocomplete from "@mui/material/Autocomplete";
import AuthService from "../../AuthService";
import BarraTitulo from "../Generico/BarraTitulo";

const PermissaoMunicipio = () => {
  const [open, setOpen] = useState(false);
  const [municipios, setMunicipios] = useState([]);
  const [municipio, setMunicipio] = useState(null);
  const [municipiosPermitidos, setMunicipiosPermitidos] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  useEffect(() => {
    handleListCidadesPermissao();
  }, []);

  const handleConfig = () => setOpen(!open);

  const handleChangeMunicipio = (event) => {
    carregarMunicipios(event.target.value);
  };

  const carregarMunicipios = (value) => {
    if (!carregando) {
      const service = new AuthService();
      service
        .get(`/municipio/list?first=0&max=9999&q=${value}`)
        .then((retorno) => {
          setMunicipios(retorno);
          setCarregando(true);
          setTimeout(() => setCarregando(false), 2540);
        });
    }
  };

  const handleListCidadesPermissao = () => {
    const service = new AuthService();
    service
      .get("/permissaoMunicipio/listOrCreate?tipo=station")
      .then(setMunicipiosPermitidos)
      .catch(console.error);
  };

  const handleSave = () => {
    const service = new AuthService();
    const permissaoMunicipio = { municipio };

    service
      .post("/permissaoMunicipio", permissaoMunicipio)
      .then((resp) => {
        setMunicipiosPermitidos((prev) => [...prev, resp]);
        setOpen(false);
      })
      .catch((err) => console.error("erro", err));
  };

  const handleDelete = (municipioObj) => {
    const service = new AuthService();

    service.delete(`/permissaoMunicipio/${municipioObj.id}`).then(() => {
      setMunicipiosPermitidos((prev) =>
        prev.filter((el) => el.id !== municipioObj.id)
      );
    });
  };

  const handleSelectMunicipio = (e, value) => {
    setMunicipio(value);
  };

  const municipioEmpresa = JSON.parse(localStorage.getItem("_profile")).empresa
    .municipio;

  return (
    <>
      <Box
        display="flex"
        flexDirection={isTablet ? "column" : "row"}
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <Box sx={{ width: "100%" }}>
          <BarraTitulo
            title="Municípios atendidos"
            subTitle="Adicione os municípios onde realiza entregas"
          />
        </Box>

        <Box
          sx={{
            width: isTablet ? "100%" : "auto",
            minWidth: "10rem",
            marginBottom: "0.75rem",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfig}
            size="medium"
            fullWidth
            startIcon={<AddIcon />}
          >
            Municípios
          </Button>
        </Box>
      </Box>

      <Paper>
        <Divider />
        <Box p={3}>
          <Grid container spacing={2}>
            {municipiosPermitidos.map((municipioObj, index) => (
              <Grid key={index}>
                <Chip
                  size="medium"
                  label={municipioObj.municipio.nome}
                  onDelete={
                    municipioEmpresa.id === municipioObj.municipio.id
                      ? null
                      : () => handleDelete(municipioObj)
                  }
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Paper>
      <Dialog maxWidth="md" fullWidth open={open} onClose={handleConfig}>
        <DialogTitle style={{ justifyContent: "center", display: "flex" }}>
          Cadastro de municipios para entrega
        </DialogTitle>

        <DialogContent>
          <Box p={3}>
            <Grid size={12}>
              <Autocomplete
                options={municipios}
                getOptionLabel={(option) => option.nomeComEstado}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={municipio}
                selectOnFocus
                onChange={handleSelectMunicipio}
                renderInput={(params) => (
                  <TextField
                    onChange={handleChangeMunicipio}
                    disabled
                    label="Municipio"
                    variant="outlined"
                    fullWidth
                    required
                    {...params}
                  />
                )}
              />
            </Grid>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            color="primary"
            variant="text"
            onClick={handleConfig}
            startIcon={<CancelIcon />}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSave}
            startIcon={<SaveIcon />}
          >
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PermissaoMunicipio;
